import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StatusBar } from "../components/Shell";
import { ChevronLeft, Bell, ShieldCheck, User, Pencil, KeyRound, FileText, BookOpen, HelpCircle, Trash2, ChevronRight } from "lucide-react";

function Toggle({ on, onClick }) {
  return (
    <button onClick={onClick} className="relative h-7 w-12 rounded-full transition-colors" style={{ background: on ? "#3b57c9" : "#d3d9ee" }}>
      <span className="absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-all" style={{ left: on ? 22 : 2 }} />
    </button>
  );
}

export default function Settings() {
  const navigate = useNavigate();
  const [toggles, setToggles] = useState({ task: true, chores: true, streak: true, weekly: false, location: true });
  const flip = (k) => setToggles((t) => ({ ...t, [k]: !t[k] }));

  const account = [
    { icon: Pencil, label: "Edit Profile" },
    { icon: KeyRound, label: "Change Password" },
    { icon: FileText, label: "Privacy Policy" },
    { icon: BookOpen, label: "Terms and Conditions" },
    { icon: HelpCircle, label: "Help & Support" },
  ];

  return (
    <div className="gd-screen bg-[#eef1fb]">
      <div className="flex-shrink-0 px-5 pb-5" style={{ background: "linear-gradient(160deg,#3b57c9,#2b3f96)", borderBottomLeftRadius: 28, borderBottomRightRadius: 28 }}>
        <StatusBar dark={false} />
        <div className="mt-1 flex items-center gap-2">
          <button onClick={() => navigate(-1)} className="gd-tap grid h-10 w-10 place-items-center rounded-full bg-white/15"><ChevronLeft size={20} color="#fff" /></button>
          <h1 className="text-2xl font-extrabold text-white">Settings</h1>
        </div>
      </div>

      <div className="gd-scroll px-4 py-4 gd-stagger">
        {/* notifications */}
        <div className="gd-card p-4">
          <div className="mb-2 flex items-center gap-2 text-sm font-extrabold text-[#3b57c9]"><Bell size={16} /> Notifications</div>
          <Row label="Task Alerts"><Toggle on={toggles.task} onClick={() => flip("task")} /></Row>
          <Row label="Chores Nearby"><Toggle on={toggles.chores} onClick={() => flip("chores")} /></Row>
          <Row label="Streak Reminders"><Toggle on={toggles.streak} onClick={() => flip("streak")} /></Row>
          <Row label="Weekly Report" last><Toggle on={toggles.weekly} onClick={() => flip("weekly")} /></Row>
        </div>

        {/* privacy */}
        <div className="gd-card mt-3 p-4">
          <div className="mb-2 flex items-center gap-2 text-sm font-extrabold text-[#3b57c9]"><ShieldCheck size={16} /> Privacy &amp; Safety</div>
          <Row label="Share Location (Real-Time Tracking)" last><Toggle on={toggles.location} onClick={() => flip("location")} /></Row>
          <p className="mt-1 text-[11px] leading-relaxed text-[#9aa3c0]">Location is only shared with your parent while a job is active.</p>
        </div>

        {/* account */}
        <div className="gd-card mt-3 p-4">
          <div className="mb-2 flex items-center gap-2 text-sm font-extrabold text-[#3b57c9]"><User size={16} /> Account</div>
          <div className="divide-y divide-[#f0f2fa]">
            {account.map((a) => (
              <button key={a.label} className="gd-tap flex w-full items-center gap-3 py-3">
                <a.icon size={17} className="text-[#7b86ab]" />
                <span className="flex-1 text-left text-sm font-semibold text-[#1f2a52]">{a.label}</span>
                <ChevronRight size={17} className="text-[#c7cde6]" />
              </button>
            ))}
          </div>
        </div>

        <button className="gd-tap mt-3 flex w-full items-center justify-center gap-2 rounded-2xl bg-[#fdece9] py-3.5 font-extrabold text-[#e0533d]">
          <Trash2 size={18} /> Delete Account
        </button>
      </div>
    </div>
  );
}

function Row({ label, children, last }) {
  return (
    <div className={`flex items-center justify-between py-3 ${last ? "" : "border-b border-[#f0f2fa]"}`}>
      <span className="text-sm font-semibold text-[#1f2a52]">{label}</span>
      {children}
    </div>
  );
}
